import React from "react";
import { Link } from "react-router-dom";
import Slider from "./Slider";
import "../styles/style.css";
import Views from "./Views";
import SecondViews from "./SecondViews";
import ThirdViews from "./ThirdViews";
import SectionA from "./SectionA";
import Accordion from "./Accordion";

const Home = () => {
  return (
    <div>
      <section className='header-section'>
        <div className='background'>
          <div className='nav-section'>
            <img
              src='https://brandlogos.net/wp-content/files/nAMr39DXwW/netflix_logo_FllsnsDw.svg'
              width='150px'
              alt='pix-1'
            />
            <Link to='/dashboard' className='btn-signIn'>
              Coutinue With Trial
            </Link>
          </div>
          <div className='showCase-section'>
            <div className='TV'>
              <h1>
                Unlimited Movies, TV <br />
                shows, and more
              </h1>
              <h2>Watch anywhere. cancel Anytime.</h2>
            </div>
            <h3>
              Ready to watch? Enter your email to create or restart your
              membership.
            </h3>
            <label for='newsletter'>
              <input
                className='newsLetter'
                type='email'
                name=''
                placeholder='Email address'
              />
              <a className='started' href='#'>
                Get Started &#62;
              </a>
            </label>
          </div>
        </div>
      </section>
      <Slider />
      <Views />
      <SecondViews />
      <ThirdViews />
      <Accordion />
      <SectionA />
    </div>
  );
};

export default Home;
